<template>
  <toggle-token-group :tokens="tokens" legend="Add your skills and services" @update:model-value="updateTokenState" />
</template>

<script lang="ts">
import ToggleTokenGroup from '@/components/toggle_token/ToggleTokenGroup.vue';
import { skillsToggleTokenOptions } from './__types__/SkillTypes';
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'SkillsStep',
  components: {
    ToggleTokenGroup,
  },
  computed: {
    accessToTransportation(): boolean {
      return this.$store.getters.getFormField('accessToTransportation');
    },
    lightHousekeeping(): boolean {
      return this.$store.getters.getFormField('lightHousekeeping');
    },
    willingToDriveChildren(): boolean {
      return this.$store.getters.getFormField('willingToDriveChildren');
    },
    willingToRunErrands(): boolean {
      return this.$store.getters.getFormField('willingToRunErrands');
    },
    homeworkHelp(): boolean {
      return this.$store.getters.getFormField('homeworkHelp');
    },
    laundry(): boolean {
      return this.$store.getters.getFormField('laundry');
    },
    mealPreparation(): boolean {
      return this.$store.getters.getFormField('mealPreparation');
    },
    comfortableWithPets(): boolean {
      return this.$store.getters.getFormField('comfortableWithPets');
    },
    pottyTraining(): boolean {
      return this.$store.getters.getFormField('pottyTraining');
    },
    sickChildren(): boolean {
      return this.$store.getters.getFormField('sickChildren');
    },
    specialNeeds(): boolean {
      return this.$store.getters.getFormField('specialNeeds');
    },
    twins(): boolean {
      return this.$store.getters.getFormField('twins');
    },
    tokens(): Object[] {
      return skillsToggleTokenOptions.map((option) => ({
        ...option,
        value: !!this[option.type],
      }));
    },
  },
  methods: {
    focusElement(options: FocusOnElementOptions = {}) {
      focusOnElement(document.querySelector('.toggle-token-group') as HTMLElement, options);
    },
    updateTokenState(newTokens) {
      newTokens.forEach((option) => {
        if (this[option.type] !== option.value) {
          this.$store.dispatch('updateForm', { key: option.type, value: option.value });
        }
      });
    },
  },
};
</script>
